import React from 'react';

import { QuestionIcon } from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import dayjs from 'dayjs';

import { IconSize } from 'constants/coreDesignSystem';
import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { alwaysTrue } from 'utils/data';

import { DocumentTestIds } from '../../document.testIds';

import { COLUMN_WIDTH, EVENT_DATE, EVENT_TYPES } from './HistoryTable.constants';

export const historyTableConfig = {
  userName: {
    label: 'User Name',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.USER,
    sort: true,
  },
  eventType: {
    label: 'Event Type',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.EVENT,
    sort: true,
    content: ({ eventType, rejectReason }) => (
      <>
        {EVENT_TYPES[eventType]}
        {EVENT_TYPES[eventType] === EVENT_TYPES.Reject && !!rejectReason && (
          <ButtonWithTooltip
            disablePortal
            data-testid={DocumentTestIds.HISTORY_TABLE_ROW_REJECT_REASON_BUTTON}
            icon={QuestionIcon}
            iconButtonClassName="p-1"
            iconSize={IconSize[18]}
            title={rejectReason}
          />
        )}
      </>
    ),
  },
  [EVENT_DATE]: {
    label: 'Event Date',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.EVENT,
    sort: true,
    renderContentAsText: alwaysTrue,
    content: action => dayjs(action[EVENT_DATE]).format(COMMON_DATETIME_FORMAT),
  },
};
